import { SVGProps, Ref, forwardRef } from 'react';

export const SkypeSolidSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M8.023 12.237c-2.34 0-3.407-1.174-3.407-2.05 0-.437.348-.76.811-.76.997 0 .742 1.497 2.62 1.497.95 0 1.506-.575 1.506-1.105 0-.322-.185-.69-.811-.829l-2.086-.53c-1.67-.414-1.97-1.358-1.97-2.21 0-1.773 1.645-2.418 3.198-2.418 1.437 0 3.152.783 3.152 1.865 0 .46-.394.714-.834.714-.858 0-.719-1.197-2.434-1.197-.857 0-1.298.391-1.298.944s.672.737 1.252.875l1.53.345c1.692.369 2.132 1.359 2.132 2.303 0 1.428-1.136 2.556-3.36 2.556M14.49 9.15c.07-.368.093-.76.093-1.151A6.58 6.58 0 0 0 8 1.414c-.394 0-.765.024-1.136.093A3.95 3.95 0 0 0 4.917 1 3.92 3.92 0 0 0 1.51 6.849c-.07.368-.093.76-.093 1.151A6.58 6.58 0 0 0 8 14.586a6 6 0 0 0 1.136-.093c.58.323 1.228.507 1.947.507a3.92 3.92 0 0 0 3.407-5.849"
                fill="currentColor"
            />
        </g>
    </svg>
));
SkypeSolidSize16Glyph.displayName = 'SkypeSolidSize16Glyph';
